import { render } from "./Speciessearch.vue?vue&type=template&id=f9f4c9a0"
import script from "./Speciessearch.vue?vue&type=script&lang=js"
export * from "./Speciessearch.vue?vue&type=script&lang=js"

import "./Speciessearch.vue?vue&type=style&index=0&id=f9f4c9a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__